import { Intent, Icon, Card, RangeSlider, NumberRange } from '@blueprintjs/core';
import { Tooltip2 } from '@blueprintjs/popover2';
import { SearchStatistics } from '@retro-ui/api-contract';

import cls from './Filter.module.css';

const STEP_SIZE = 1;

interface ReactionCountFilterCardProps {
  reactionCountStatistics: SearchStatistics['reactionCount'];
  value?: NumberRange;
  onChange: (value?: NumberRange) => void;
}
export function ReactionCountFilterCard(props: ReactionCountFilterCardProps) {
  const { reactionCountStatistics, value, onChange } = props;

  const onSliderChange = (range: NumberRange) => {
    const [min, max] = range;

    const sameAsInitial = min === reactionCountStatistics.min && max === reactionCountStatistics.max;

    const value = sameAsInitial ? undefined : range;

    onChange(value);
  };

  const renderLabel = (rawNumber: number) => {
    if (rawNumber === 0) {
      return (
        <span className={cls.rangeLabel}>
          <span>0</span>{' '}
          <Tooltip2 content="Results with reaction count of 0 are commercially available.">
            <Icon icon="help" size={12} />
          </Tooltip2>
        </span>
      );
    }

    return String(rawNumber);
  };

  if (!reactionCountStatistics || reactionCountStatistics.min == null || reactionCountStatistics.max == null) {
    return null;
  }

  return (
    <Card>
      <small className={cls.label}>NUMBER OF REACTIONS</small>
      <div>
        <div className={cls.rangeSliderContainer}>
          {reactionCountStatistics.min < reactionCountStatistics.max ? (
            <RangeSlider
              showTrackFill
              min={reactionCountStatistics.min}
              max={reactionCountStatistics.max}
              value={value ?? [reactionCountStatistics.min, reactionCountStatistics.max]}
              stepSize={STEP_SIZE}
              intent={Intent.PRIMARY}
              labelRenderer={renderLabel}
              onChange={onSliderChange}
            />
          ) : (
            <RangeSlider
              disabled
              showTrackFill
              min={reactionCountStatistics.min}
              max={reactionCountStatistics.min + 1}
              value={[reactionCountStatistics.min, reactionCountStatistics.min + 1]}
              stepSize={STEP_SIZE}
              intent={Intent.PRIMARY}
              labelRenderer={() => renderLabel(reactionCountStatistics.min ?? 0)}
            />
          )}
        </div>
      </div>
    </Card>
  );
}
